/**
 * Rótulos cortos de un documento para filas de lista (Favoritos): chip de tipo y línea de metadatos.
 * `tipo` llega en MAYÚSCULAS para SII/TTA y en minúsculas para BCN; aquí se compara en minúscula.
 */
import { fechaCorta } from './fechas';

const TIPO: Record<string, string> = {
  oficio: 'Oficio',
  circular: 'Circular',
  resolucion: 'Resolución',
  convenio: 'Convenio',
  jurisprudencia: 'Sentencia',
  ley: 'Ley',
  dl: 'Decreto ley',
  dfl: 'DFL',
  decreto: 'Decreto',
};

export function tipoCorto(tipo: string | null | undefined): string {
  const t = (tipo || '').toLowerCase();
  return TIPO[t] || (t ? t.charAt(0).toUpperCase() + t.slice(1) : 'Documento');
}

/** Plural para Cobertura («Oficios», «Sentencias»). */
export function tipoPlural(tipo: string): string {
  const s = tipoCorto(tipo);
  if (s === 'Resolución') return 'Resoluciones';
  if (s === 'Decreto ley') return 'Decretos ley';
  if (s === 'DFL') return 'DFL';
  if (s === 'Ley') return 'Leyes';
  // En consonante, «es» («Circulares»); en vocal, «s» («Oficios», «Sentencias», «Decretos»).
  return /[aeiou]$/i.test(s) ? `${s}s` : `${s}es`;
}

interface DocMeta {
  tipo?: string | null;
  numero?: string | null;
  year?: number | null;
  fecha_publicacion?: string | null;
}

/**
 * «N° 2609 · 1 oct 2026» (SII), «GR-10-00060-2026 · 12 mar 2026» (TTA), «1974» (leyes y convenios: el número ya
 * va en el título). Un campo vacío no se muestra.
 */
export function metaDocumento(doc: DocMeta): string {
  const t = (doc.tipo || '').toLowerCase();
  const partes: string[] = [];
  if (['oficio', 'circular', 'resolucion'].includes(t)) {
    if (doc.numero) partes.push(`N° ${doc.numero}`);
    const f = fechaCorta(doc.fecha_publicacion);
    partes.push(f || (doc.year ? String(doc.year) : ''));
  } else if (t === 'jurisprudencia') {
    if (doc.numero) partes.push(doc.numero);
    const f = fechaCorta(doc.fecha_publicacion);
    partes.push(f || (doc.year ? String(doc.year) : ''));
  } else if (doc.year) {
    partes.push(String(doc.year));
  }
  return partes.filter(Boolean).join(' · ');
}
